import router from "../../../../router";
import { isThisTypeNode } from "typescript";

export default {
    data() {
        return {
            showModal: false,
            isError: false,

            username: '',
            password: '',
            remember: '',
            message: '',
            verificationCode: '',

            errMailAddress: false,
            errPassword: false,
            errAuth: false,
            mailAddressErrors: [],
            passwordErrors: [],
            authErrors: [],

            isProcessing: false,
            showVerification: false,
            showResendVerificationModal: false,
            showSendVerificationErrorModal: false,
        }
    },

    methods: {
        errorHandler: function(content) {
            if (content.errors == undefined) {
                return true;
            } else {
                console.error(content.errors);
            }

            if (content.errors.mail_address != undefined) {

                this.errMailAddress = true;
                this.mailAddressErrors = [];
                for (var key in content.errors.mail_address) {
                    var item = content.errors.mail_address[key];
                    this.mailAddressErrors.push(item);
                }
            }
            if (content.errors.password != undefined) {

                this.errPassword = true;
                this.passwordErrors = [];
                for (var key in content.errors.password) {
                    var item = content.errors.password[key];
                    this.passwordErrors.push(item);
                }
            }
            if (content.errors.auth != undefined) {

                this.errAuth = true;
                this.authErrors = [];
                for (var key in content.errors.auth) {
                    var item = content.errors.auth[key];
                    this.authErrors.push(item);
                }
            }

            if (content.errors.verification != undefined) {
                this.errVerification = true;
                this.verificationErrors = [content.errors.verification];
            }
            return false;
        },


        login(authType) {
            this.errMailAddress = false;
            this.mailAddressErrors = [];
            this.errPassword = false;
            this.passwordErrors = [];
            this.errAuth = false;
            this.authErrors = [];
            this.errVerification = false;
            this.verificationErrors = [];

            this.message = "";
            this.isError = false;
            var isInvalid = false;

            if (this.username === '') {
                isInvalid = true;
            }
            if (this.password === '') {
                isInvalid = true;
            }
            /*if(isInvalid) {
                this.isError = true;
                return;
            }*/

            this.isProcessing = true;

            this.$store.commit('overlay', true);

            // 認証処理
            var res = this.$store.dispatch(authType, {
                'userId': this.username,
                'password': this.password,
                // 2019-10-28 kato PWA作業スケジュール No.27（実装そのものを追加）
                'remember': (this.remember ? 'on' : ''),
                'code': this.verificationCode,
            });

            res.then(function(res) {
                //console.log(res);

                var content = res.data;

                console.log("response", content);

                if (content.status_number == "200") {

                    console.log("user logged in : ", content.content);

                    try {
                        this.$store.commit("login", {
                            'userId': content.content.user_id,
                            'userName': content.content.user_name,
                            'grant': content.content.user_grant,
                            'authToken': content.content["auth-token"],
                            'remember': this.remember
                        });
                        //console.log(this.$route.query.redirect);
                        if (this.$route.query.redirect) {
                            this.$router.push(this.$route.query.redirect);
                        } else {
                            this.$router.push({ path: '/user/categories' });
                        }
                    } catch (e) {
                        console.error(e);
                    }

                } else if (content.status_number == "401") {

                    if (content.content["verification-requrired"]) {

                        if (content.content["error"] == true) {
                            this.showSendVerificationErrorModal = true;

                        } else {
                            //2要素認証
                            this.showVerification = true;
                        }

                    } else {
                        //認証失敗 401で返却される
                        var result = this.errorHandler(content.content);
                        if (!result) {
                            this.isProcessing = false;
                            this.$store.commit('overlay', false);
                            return;
                        }
                    }

                } else {
                    console.error("バリデーションエラー");
                    var msg = content.content.message;
                    this.message = msg;
                    console.log(msg);
                }

                this.isProcessing = false;
                this.$store.commit('overlay', false);

            }.bind(this)).catch(function(err) {
                console.error(err);
                this.isProcessing = false;
                this.$store.commit('overlay', false);

            }.bind(this));

            return;


        },

        doLogin() {
            this.login("authenticate");
        },
        doVerification() {
            this.login("verification");
        },
        resendVarification() {
            var handler = Vue.ELearning.Authenticatior.resendVerification({
                'userId': this.username,
            });

            handler.then(function(res) {

                var content = res.data;
                if (content.content["error"] == true) {
                    this.showSendVerificationErrorModal = true;
                } else {
                    this.showResendVerificationModal = true;
                }

            }.bind(this)).catch(function(res) {
                this.showSendVerificationErrorModal = true;

            }.bind(this));
        }
    },

    mounted() {
        // 2019-11-28 kato テストアップサイト：なるほどーが修正一覧 No11
        // autocomplete="off" を追加したが効かないことがあるので強制的にクリア
        if (this.$refs.username) {
            this.$refs.username.value = '';
        }
        if (this.$refs.password) {
            this.$refs.password.value = '';
        }

        if (this.$store.state.isLoggedInDestroyed) {
            this.$dialog.message("同じIDでログインされたため、ログアウトしました。");
            this.$store.commit('loginDestroyed', false);
        }
    }
}